<template>
  <div id="team" class="site">
    <h1>ocular collective</h1>
    <article class="team-wrapper">
      <portrait-section></portrait-section>
    </article>
  </div>
</template>

<script>
import PortraitSection from "@/components/Team/PortraitSection.vue";
export default {
  name: "Team",
  title: "Team - Ocular",
  components: {
    PortraitSection,
  },
};
</script>

<style lang="scss" scoped>
#team {
  .team-wrapper {
    padding: 0 10vw 0 10vw;
    p {
      text-align: left;
    }
    .teambilder-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
      .teambild {
        width: 10rem;
        height: 5rem;
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  #team {
    .team-wrapper {
      padding: 0;
    }
  }
}
</style>
